"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/usr/src/app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _withGTM = _interopRequireDefault(require("./withGTM"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var GTMPageData = /*#__PURE__*/function (_react$default$Compon) {
  _inherits(GTMPageData, _react$default$Compon);

  var _super = _createSuper(GTMPageData);

  function GTMPageData() {
    _classCallCheck(this, GTMPageData);

    return _super.apply(this, arguments);
  }

  _createClass(GTMPageData, [{
    key: "getSysEnv",
    value: function getSysEnv() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return 'mobile';
      }

      return 'desktop';
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this$props = this.props,
          gtmData = _this$props.gtmData,
          breadcrumb = _this$props.breadcrumb,
          pageId = _this$props.pageId;

      if (gtmData) {
        gtmData.breadcrumb = breadcrumb || pageId;
        gtmData.pageId = pageId || breadcrumb;
      }

      if (typeof digitalData !== 'undefined') {
        var loaded = !!window.digitalData.find(function (d) {
          return d.event === 'gtm.load';
        });
        var environment = gtmData.environment,
            site = gtmData.site,
            siteType = gtmData.siteType,
            language = gtmData.language,
            country = gtmData.country;

        if (loaded) {
          window.digitalData.push({
            page: {
              pageInfo: {
                breadcrumbs: breadcrumb || pageId,
                country: country.toLowerCase(),
                destinationURL: document.location.href,
                environment: environment,
                language: language.toLowerCase(),
                pageID: pageId || breadcrumb,
                pageName: document.title,
                referringURL: document.referrer,
                site: site,
                siteType: siteType,
                sysEnv: this.getSysEnv()
              }
            }
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return GTMPageData;
}(_react.default.Component);

_defineProperty(GTMPageData, "propTypes", {
  gtmData: _propTypes.default.object,
  breadcrumb: _propTypes.default.string,
  pageId: _propTypes.default.string
});

_defineProperty(GTMPageData, "defaultProps", {
  gtmData: {},
  breadcrumb: null,
  pageId: null
});

var _default = (0, _withGTM.default)()(GTMPageData);

exports.default = _default;